import { cn } from "@/components/ui/utils";

type ActiveStreamingLabelProps = {
  active: boolean;
  children: React.ReactNode;
};

/** Muted label with a horizontal color ribbon when the agent step is active. */
export function ActiveStreamingLabel({
  active,
  children,
}: ActiveStreamingLabelProps) {
  return (
    <span
      className={cn(
        active && "streaming-active-label",
        "text-xs [line-height:1.5]",
        active ? "text-transparent" : "text-muted-foreground/80",
      )}
    >
      {children}
    </span>
  );
}
